(() => {
  let activeCard = null;

  const findCard = (trigger) => {
    let node = trigger;
    while (node && node !== document.body) {
      if (node.dataset?.url && (node.dataset.variantId || node.dataset.title)) return node;
      node = node.parentElement;
    }
    return null;
  };

  const findOpenModal = () => Array.from(document.querySelectorAll('.open')).find((element) =>
    element.querySelector('[id*="modal-title"], [class*="modal-title"]') &&
    element.querySelector('[id*="modal-price"], [class*="modal-price"]')
  );

  const selectedVariantId = (modal, card) => String(
    modal.querySelector('select[id*="variant"], select[name="id"]')?.value ||
    card.dataset.variantId || card.dataset.vid || ''
  );

  const ensureQuantity = (modal, minimum) => {
    let input = modal.querySelector('input[id*="qty"], input[name="quantity"], input[type="number"]');
    if (input) {
      input.min = minimum;
      input.value = Math.max(minimum, parseInt(input.value, 10) || minimum);
      const row = input.closest('[class*="qty"], [class*="quantity"]');
      if (row) row.style.setProperty('display', 'flex', 'important');
      return input;
    }
    const price = modal.querySelector('[id*="modal-price"], [class*="modal-price"]');
    if (!price) return null;
    const row = document.createElement('div');
    row.className = 'mkp-commerce-qty mkp-commerce-qty--injected';
    row.innerHTML = `<span>Quantity</span><button type="button" data-mkp-qty="minus" aria-label="Decrease quantity">−</button><input type="number" value="${minimum}" min="${minimum}" readonly><button type="button" data-mkp-qty="plus" aria-label="Increase quantity">+</button>`;
    price.insertAdjacentElement('afterend', row);
    input = row.querySelector('input');
    row.addEventListener('click', (event) => {
      const value = parseInt(input.value, 10) || minimum;
      if (event.target.dataset.mkpQty === 'minus' && value > minimum) input.value = value - 1;
      if (event.target.dataset.mkpQty === 'plus') input.value = value + 1;
    });
    return input;
  };

  const enhance = async () => {
    const modal = findOpenModal();
    const card = activeCard;
    if (!modal || !card) return;
    modal.dataset.mkpEnhanced = 'true';
    modal._mkpCard = card;

    const title = modal.querySelector('[id*="modal-title"], [class*="modal-title"]');
    const price = modal.querySelector('[id*="modal-price"], [class*="modal-price"]');
    let sku = modal.querySelector('[id*="modal-sku"], .mkp-commerce-sku');
    if (!sku) {
      sku = document.createElement('div');
      sku.className = 'mkp-commerce-sku';
      title.insertAdjacentElement('afterend', sku);
    }

    let minimumOrder = modal.querySelector('[id*="modal-moq"], [class*="modal-price-moq"], .mkp-commerce-min-order');
    if (!minimumOrder) {
      minimumOrder = document.createElement('div');
      minimumOrder.className = 'mkp-commerce-min-order';
      sku.insertAdjacentElement('afterend', minimumOrder);
    }
    const minimum = Math.max(1, parseInt(card.dataset.moq, 10) || 1);
    minimumOrder.textContent = `Min. Order: ${minimum} pc`;
    minimumOrder.classList.remove('hidden');
    minimumOrder.style.removeProperty('display');
    ensureQuantity(modal, minimum);

    const fallbackSku = (card.dataset.sku || '').split(',')[0];
    sku.textContent = fallbackSku ? `SKU: ${fallbackSku}` : 'SKU: Loading…';
    sku.classList.remove('hidden');
    sku.style.removeProperty('display');

    try {
      const url = `${card.dataset.url.split('?')[0].replace(/\.js$/, '')}.js`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      const updateSku = () => {
        const id = selectedVariantId(modal, card);
        const variant = product.variants.find((item) => String(item.id) === id) || product.variants[0];
        sku.textContent = variant?.sku ? `SKU: ${variant.sku}` : 'SKU: Not assigned';
      };
      updateSku();
      const select = modal.querySelector('select[id*="variant"], select[name="id"]');
      if (select) select.onchange = updateSku;
    } catch (error) {
      sku.textContent = fallbackSku ? `SKU: ${fallbackSku}` : 'SKU: Not assigned';
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('button, a');
    if (!trigger || !/see preview/i.test(trigger.textContent)) return;
    activeCard = findCard(trigger);
    window.setTimeout(enhance, 120);
  }, true);

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('button');
    const modal = button?.closest('.open');
    const injected = modal?.querySelector('.mkp-commerce-qty--injected input');
    if (!button || !modal || !injected || !/add to cart/i.test(button.textContent) || !modal._mkpCard) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const id = Number(selectedVariantId(modal, modal._mkpCard));
    const quantity = Number(injected.value);
    if (!id || !quantity) return;
    const original = button.textContent;
    button.disabled = true;
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity })
      });
      if (!response.ok) throw new Error('Cart request failed');
      button.textContent = '✓ Added!';
    } catch (error) {
      button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1800);
    }
  }, true);
})();
